module.exports = __webpack_public_path__ + "static/media/Sa.dec03b12.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/Sa.mp3
// module id = 44
// module chunks = 0